<script setup lang="ts">
import { Log } from "@/interfaces/Log.ts";
import {
  PaginatedResponse,
  Pagination,
} from "@/interfaces/paginatedResponse.ts";
import PaginateNav from "@/modules/trips/components/PaginateNav.vue";
import AuditTableRow from "./AuditTableRow.vue";

interface Props {
  logs: Log[];
  pagination: Pagination;
  page: string | number;
  classTable?: string;
}

interface Emits {
  (e: "setPage", page: number | string): void;
  (e: "search"): void;
}

const props = withDefaults(defineProps<Props>(), {
  classTable: "w-3/4 h-auto mx-auto my-4 flex flex-col",
});

const emits = defineEmits<Emits>();

const handlePage = (newPage: string | number) => {
  const pageNumber = Number(newPage);

  if (pageNumber >= 1 && pageNumber <= props.pagination.meta.lastPage!) {
    emits("setPage", pageNumber);
    emits("search");
  }
};
</script>

<template>
  <div :class="classTable">
    <div class="flex flex-col">
      <div class="flex-1 bg-white rounded-lg p-8">
        <h4 class="text-xl text-gray-900 font-extrabold">
          Historial de cambios
        </h4>
        <div class="mt-3 overflow-x-auto">
          <table class="min-w-full divide-y divide-gray-200 overflow-x-scroll">
            <thead class="bg-gray-50">
              <tr>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Evento
                </th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Fecha
                </th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Datos antiguos
                </th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Datos nuevos
                </th>
              </tr>
            </thead>

            <tbody class="">
              <AuditTableRow v-for="(log, i) in logs" :key="i" :log="log" />
            </tbody>
          </table>
        </div>
        <paginate-nav :pagination="pagination" :page="page" :handle-page="handlePage" :data="logs"
          footer-text="Ningún cambio encontrado" />
      </div>
    </div>
  </div>
</template>

<style></style>
